/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersControllerPatchMutationRequest,
  TelegramUsersControllerPatchMutationResponse,
  TelegramUsersControllerPatch401,
} from '../../types/TelegramUsersControllerPatch.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramUsersPatch } from '../../methods/telegramUsersPatch.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramUsersPatchMutationKey = () => [{ url: '/api/telegram/users' }] as const;

export type TelegramUsersPatchMutationKey = ReturnType<typeof telegramUsersPatchMutationKey>;

/**
 * {@link /api/telegram/users}
 */
export function useTelegramUsersPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramUsersControllerPatchMutationResponse,
      ResponseErrorConfig<TelegramUsersControllerPatch401>,
      { data?: TelegramUsersControllerPatchMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramUsersControllerPatchMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramUsersPatchMutationKey();

  return useMutation<
    TelegramUsersControllerPatchMutationResponse,
    ResponseErrorConfig<TelegramUsersControllerPatch401>,
    { data?: TelegramUsersControllerPatchMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramUsersPatch(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
